// extracted by css-extract-rspack-plugin
export default {"CircleBadge":"MarketplaceListings-module__CircleBadge__k6Pf9EF"};